/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Lottie from "lottie-react";
/* Components */
import Button from "../components/button/button";
import HistoryEmpty from "../assets/icons/history_toggle_off.svg";
/* Assets */
//import ChatArrow from '../assets/chatwrapper/arrow.svg';
import ArrowBack from '../assets/icons/arrow_back.svg';
//import HourWatch from '../assets/icons/watch_later.svg';
import { useTranslation } from 'react-i18next';
import FormABP from '../components/form/formABP';
import UseCaseHistory from '../components/UseCaseHistory/UseCaseHistory';
import { getSessionsByUseCase } from '../services/teacherSession.service';
import useChatGPTStore from '../store/useChatGPT.store';
import { useMutation } from 'react-query';
import { useMediaQuery } from "react-responsive";
import useGlobalStore from "../store/useGlobalStore";
import TextRotator from "../components/textRotator/textRotator";
/* Animations */
import soundWave from "../assets/animations/sounWave.json";
import ShaiaCreate from "../assets/shaia_create.png";

const DesignABP = () => {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(false);
  const [isView, setIsView] = useState(null);
  const {  history, setHistory, setFormObject } = useChatGPTStore();
  const isMobile = useMediaQuery({ maxWidth: 768 });  
  const navigate = useNavigate();
  // eslint-disable-next-line
  const { gptLoading } = useGlobalStore();

  const questions =  [
    { field: "clase", question: "Clase" },
    { field: "grado", question: "Grado" },
    { field: "edad", question: "Edades" },
    { field: "numEstudiantes", question: "Número estudiantes" },
    { field: "objetivos", question: "Objetivos" },
    { field: "numClases", question: "Cantidad de clases" },
    { field: "duracion", question: "Duración de cada clase" },
    { field: "recursos", question: "Materiales" },
    { field: "conocimientos", question: "Conocimientos previos" },
    { field: "intereses", question: "Intereses" },
    { field: "consideraciones", question: "Consideraciones" },
  ]

  const styleJSON_wave = {
    width: isMobile ? 174 : 254,
    height: isMobile ? 174 : 254,
    position: "absolute",
  };

  const texts = [
    `${t("principio_1")}`,
    `${t("principio_2")}`,
    `${t("principio_3")}`,
    `${t("principio_4")}`,
    `${t("principio_5")}`,
    `${t("principio_6")}`,
    `${t("principio_7")}`,
    `${t("principio_8")}`,
    `${t("principio_9")}`,
    `${t("principio_10")}`,
  ];
  
  useEffect(() => {
    teacherSessionMutation.mutate("abp3");
    // eslint-disable-next-line
  }, []);

  const teacherSessionMutation = useMutation(getSessionsByUseCase, {
    onSuccess: (res) => {
      setHistory(res);
    },
    onError: () => {},
  });

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  function parseTextToKeyValuePairs(text) {
    // Divide el texto en segmentos por tres espacios, asumiendo dos después del valor
    const segments = text.split("  ");
    const keyValuePairs = {};
  
    segments.forEach((segment) => {
      // Divide cada segmento por el primer dos puntos encontrado
      const [key, value] = segment.split(":").map((part) => part.trim());
      keyValuePairs[key] = value;
    });
  
    return keyValuePairs;
  }
  

  const getBuildForm = (formContext) => {
    const contextObject = parseTextToKeyValuePairs(formContext);
  const parsedQuestions = questions.reduce((acc, question) => {
    const value = contextObject[question.question];
    if (value) {
      acc.push({ field: question.field, value: value });
    }
    return acc;
  }, []);
  return parsedQuestions;
  };


  const toggleView = (buttonName, data) => {
    const arrayMessages = JSON.parse(data.memory_array);
    const conditions = ["Context:", "contextoUsuario:"];
    const userMessage = arrayMessages.find(
      (e) =>
        (e?.role === "user" || e?.type === "human") &&
        conditions.some((s) => e?.content?.includes(s) || e?.data?.content?.includes(s))
    );
    if(userMessage){
      const parsedUserMessage = userMessage?.content || userMessage?.data?.content;
      const parsedForm = parsedUserMessage.replace("contextoUsuario: ","").replace("Context: ","").trim();
     const buildForm = getBuildForm(parsedForm, questions)
     setFormObject(buildForm);
    }
    navigate(`/editing-abp-board?sessionId=${data.session_id}`);
    setIsView(buttonName);
    if (isActive) {
      toggleClass();
    }
  };

  return (
    <>
      <div className="back-button">
        <Link to={"/"} className="back-button_arrow">
          <img src={ArrowBack} className="" alt="" />
          {t("inicio")}
        </Link>
        <span className="back_button_root">{t("activityText1")} /</span>
        <span className="back_button_page">{t("abpText1")}</span>
      </div>
      <div className="wrapper d-dialog">
        <div className={`editor_board-animation ${gptLoading ? "overlay" : ""}`}>
          <div className="animation-wrapper">
            <Lottie animationData={soundWave} style={styleJSON_wave} />
            <div className="wrapper-shaia_speak">
              <img src={ShaiaCreate} alt="Shaia" />
            </div>
          </div>
          <div className="content-text">
            <p>
              {t("espera_pagina_espera1")}. {t("espera_pagina_espera2")}.
            </p>
            <p>{t("espera_pagina_espera3")}:</p>
            <TextRotator texts={texts} interval={10000} />
          </div>
        </div>
        <div className={`chat_sidebar editOff`}>
          <div className="sidebar_chat">
            <div className="chat-content">
              <div className="chat-content_title">
                <div className="text-xl">
                  <strong>{t("activityText3")}</strong> 👋
                  <br />
                  {t("abp_titulo1")}
                  <br /><br />
                  {t("abp_titulo2")}
                  <br /><br />
                  {t("abp_titulo3")}
                </div>
              </div>
              <div className="chat-content_wrapper">
                <FormABP />
              </div>
            </div>
          </div>
          <div className={`sidebar_history h-full max-h-desktopWrapper ${isActive ? "active" : ""}`}>
            <h6 className="blue-text sidebar-title">
              {t("historialTitulo")}
            </h6>
            {history.length ? (
              <UseCaseHistory
                history={history}
                sessionId={null}
                isView={isView}
                toggleView={toggleView}
              />
            ) : (
              <>
                <div className="history_empty">
                  <img src={HistoryEmpty} alt="empty" />
                  <p className="blue-text">{t("historialTituloVacio")}</p>
                </div>
              </>
            )}
            <Button
              label="Cerrar"
              variant="primary-outline"
              onClick={toggleClass}
            />
          </div>
        </div>
        <div className="main-helper">
          <Button label={t("historialTitulo")} variant="tertiary" onClick={toggleClass} />
        </div>
      </div>
    </>
  );
}

export default DesignABP;